"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseContract = exports.parseCalldata = exports.wait = void 0;
var json_1 = require("./json");
var number_1 = require("./number");
var stark_1 = require("./stark");
function wait(delay) {
    return new Promise(function (res) {
        setTimeout(res, delay);
    });
}
exports.wait = wait;
function parseCalldata(calldata) {
    if (calldata === void 0) { calldata = []; }
    return calldata.map(function (data) {
        if (typeof data === 'string' && (0, number_1.isHex)(data)) {
            return data;
        }
        return (0, number_1.toHex)((0, number_1.toBN)(data));
    });
}
exports.parseCalldata = parseCalldata;
function parseContract(contract) {
    var parsedContract = typeof contract === 'string' ? (0, json_1.parse)(contract) : contract;
    return __assign(__assign({}, parsedContract), { program: (0, stark_1.compressProgram)(parsedContract.program) });
}
exports.parseContract = parseContract;
